import { cx } from "~/tools/class-variance";
import type { Record } from "~/tools/record";

import type { BorgStatus } from "./models/borg-types";

export interface StatusBadgeConfig {
	className: string;
	label: string;
}

const STATUS_CONFIG: Record<BorgStatus, StatusBadgeConfig> = {
	completed: { className: cx("bg-green-100 text-green-700"), label: "Complete" },
	// biome-ignore lint/style/useNamingConvention: borg status value
	in_progress: { className: cx("bg-blue-100 text-blue-700"), label: "Running" },
	failed: { className: cx("bg-red-100 text-red-700"), label: "Failed" },
	// biome-ignore lint/style/useNamingConvention: borg status value
	timed_out: { className: cx("bg-yellow-100 text-yellow-700"), label: "Timed out" },
	canceling: { className: cx("bg-grey-100 text-grey-600"), label: "Stopping" },
	cancelled: { className: cx("bg-grey-100 text-grey-600"), label: "Cancelled" },
};

export const getBorgStatusConfig = (status: BorgStatus): StatusBadgeConfig => STATUS_CONFIG[status];
